import styled from 'styled-components'
import { Box } from '../atoms/Box'

export const ModalHeader = styled(Box)`
  padding: 20px 26px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const ModalBody = styled(Box)`
  padding: 26px;
  max-height: 70vh;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.background.secondary};

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.border.default};
  }
`

export const ModalFooter = styled(Box)`
  padding: 16px 26px;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.primary};
`

export const PreviewContainer = styled.div`
  transform-origin: top center;
  transition: transform 0.2s ease-out;
`

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`

export const LoadingCard = styled.div`
  background: white;
  border-radius: 13px;
  padding: 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 384px;
  width: 90%;
`

export const LoadingHeader = styled.div`
  text-align: center;
  margin-bottom: 26px;
`

export const LoadingTitle = styled.h3`
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
`

export const LoadingSubtitle = styled.p`
  margin: 0;
  font-size: 10px;
  color: #64748b;
  line-height: 1.5;
`

export const ProgressSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`

export const ProgressStep = styled.div<{
  $status: 'pending' | 'active' | 'completed'
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: ${({ $status }) =>
    $status === 'active'
      ? '#f0f9ff'
      : $status === 'completed'
        ? '#f0fdf4'
        : '#f8fafc'};
  border: 1px solid
    ${({ $status }) =>
      $status === 'active'
        ? '#bae6fd'
        : $status === 'completed'
          ? '#bbf7d0'
          : '#e2e8f0'};
  transition: all 0.3s ease;
`

export const StepIcon = styled.div<{
  $status: 'pending' | 'active' | 'completed'
}>`
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;

  ${({ $status }) =>
    $status === 'active'
      ? `
    background: linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%);
    color: white;
    animation: pulse 2s ease-in-out infinite;
  `
      : $status === 'completed'
        ? `
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
  `
        : `
    background: #e2e8f0;
    color: #94a3b8;
  `}

  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(14, 165, 233, 0.4);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 0 0 8px rgba(14, 165, 233, 0);
    }
  }
`

export const StepContent = styled.div`
  flex: 1;
`

export const StepTitle = styled.div<{
  $status: 'pending' | 'active' | 'completed'
}>`
  font-size: 10px;
  font-weight: 600;
  color: ${({ $status }) => ($status === 'pending' ? '#94a3b8' : '#1e293b')};
  margin-bottom: 2px;
`

export const StepDescription = styled.div`
  font-size: 10px;
  color: #64748b;
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
`

export const ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background: linear-gradient(90deg, #0ea5e9 0%, #06b6d4 100%);
  transition: width 0.3s ease;
  border-radius: 3px;
`
